import { canUseStatistics } from '@/utils/cookieConsent';

const KEYS = {
  searchHistory: 'byggfynd_searchHistory',
  viewedProducts: 'byggfynd_viewedProducts',
  viewedCategories: 'byggfynd_viewedCategories',
  clickedProducts: 'byggfynd_clickedProducts',
};

const MAX_ITEMS = 20;

function readArray(key) {
  if (typeof window === 'undefined' || !window.localStorage) return [];
  try {
    const raw = window.localStorage.getItem(key);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function writeArray(key, arr) {
  if (typeof window === 'undefined' || !window.localStorage) return;
  if (!canUseStatistics()) return;
  try {
    window.localStorage.setItem(key, JSON.stringify(arr.slice(0, MAX_ITEMS)));
  } catch {
    /* ignore quota / private mode */
  }
}

function pushUnique(key, value) {
  const v = value == null ? '' : String(value).trim();
  if (!v) return;
  const prev = readArray(key).filter((x) => String(x) !== v);
  prev.unshift(v);
  writeArray(key, prev);
}

export function trackSearch(query) {
  if (!canUseStatistics()) return;
  const q = String(query || '').trim();
  if (q.length < 2) return;
  pushUnique(KEYS.searchHistory, q);
}

export function trackProductView(productId) {
  if (!canUseStatistics()) return;
  if (!productId) return;
  pushUnique(KEYS.viewedProducts, productId);
}

export function trackCategoryVisit(categoryId) {
  if (!canUseStatistics()) return;
  if (!categoryId || categoryId === 'all') return;
  pushUnique(KEYS.viewedCategories, categoryId);
}

export function trackProductClick(productId) {
  if (!canUseStatistics()) return;
  if (!productId) return;
  pushUnique(KEYS.clickedProducts, productId);
}

/** Rensar lokalt spårade beteendesignaler (vid nekad statistik eller när användaren återkallar). */
export function clearBehaviorTrackingData() {
  if (typeof window === 'undefined' || !window.localStorage) return;
  try {
    Object.values(KEYS).forEach((k) => window.localStorage.removeItem(k));
  } catch {
    /* ignore */
  }
}

export function getBehaviorPayload() {
  if (!canUseStatistics()) {
    return {
      searchHistory: [],
      viewedProducts: [],
      viewedCategories: [],
      clickedProducts: [],
    };
  }
  return {
    searchHistory: readArray(KEYS.searchHistory),
    viewedProducts: readArray(KEYS.viewedProducts),
    viewedCategories: readArray(KEYS.viewedCategories),
    clickedProducts: readArray(KEYS.clickedProducts),
  };
}

export function hasAnyBehaviorSignals() {
  const p = getBehaviorPayload();
  return (
    p.searchHistory.length > 0 ||
    p.viewedProducts.length > 0 ||
    p.viewedCategories.length > 0 ||
    p.clickedProducts.length > 0
  );
}
